/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://sumxcipwwa.execute-api.eu-west-2.amazonaws.com/archer",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:4c378fb1-3481-4375-a5ec-f205c435adab",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_4HYaHJF9P",
    "aws_user_pools_web_client_id": "21e274vmk1c0vs1sd12eo0jrhd",
    "oauth": {
        "domain": "cyf-archer.auth.eu-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://dev.app.compareyourfootprint.com/,https://staging2.app.compareyourfootprint.com/,https://staging.app.compareyourfootprint.com/,https://app.compareyourfootprint.com/",
        "redirectSignOut": "https://dev.app.compareyourfootprint.com/,https://staging2.app.compareyourfootprint.com/,https://staging.app.compareyourfootprint.com/,https://app.compareyourfootprint.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cognito_login_mechanisms": [
        "EMAIL",
        "PHONE_NUMBER",
        "GOOGLE"
    ]
};


export default awsmobile;
